<template>
  <div class="container">
    <!-- Filtlro -->
    <v-form ref="form">
      <p>Buscar Por:</p>
      <v-row class="justify-start mt-3 ml-3">
        <v-col :cols="6" >
          <v-autocomplete
              v-model="form.filters.gre"
              label="GRE"
              dense
              outlined
              item-text="nome"
              item-value="codigo"
              return-object
              :items="form.listaGerenciasRegionais"
          />
        </v-col>
      </v-row>
      <v-row class="btn-group">
        <v-col class="text-end">
          <v-btn
              color="primary"
              @click="resetForm"
              outlined
          >
            Limpar
          </v-btn>
          <v-btn
              color="primary"
              @click="buscarDashboardGre"
          >
            Buscar
          </v-btn>
        </v-col>
      </v-row>
    </v-form>

    <div v-if="dashboard != null" class="mt-7">

      <!-- Status -->
      <StatusFormacao
          @visualizar-listagem="openDialogListarStatusFormacao(null)"
          :status-list = "dashboard?.statusFormacao"
          :data-hora-info="dashboard?.dataHoraInfo"
      />
      <!-- Cards -->
      <v-row>
        <v-col cols="12" md="4">
          <v-card class="pa-4 text-center">
            <div class="subtitle-2 mb-2 font-weight-medium">Total De Formações</div>
            <div class="display-1 font-weight-bold blue--text mb-2">{{ dashboard?.info?.totalFormacoes }}</div>
            <v-btn outlined small color="blue" @click="openDialogListarFormacoesGre()">Visualizar Listagem</v-btn>
          </v-card>
        </v-col>

        <v-col cols="12" md="4">
          <v-card class="pa-4 text-center">
            <div class="subtitle-2 mb-2 font-weight-medium">Participantes</div>
            <div class="display-1 font-weight-bold orange--text mb-2">{{ dashboard?.info?.totalParticipantes }}</div>
            <v-btn outlined small color="orange" @click="openDialogListarParticipantesGre()" >Visualizar Listagem</v-btn>
          </v-card>
        </v-col>

        <v-col cols="12" md="4">
          <v-card class="pa-4 text-center">
            <div class="subtitle-2 mb-2 font-weight-medium">Média De Frequência</div>
            <div class="display-1 font-weight-bold green--text mb-9">{{ dashboard?.info?.mediaFrequencia }}%</div>
          </v-card>
        </v-col>
      </v-row>

      <!-- Grafico Pizza-->

      <v-row style="height: 500px" class="fill-height">
        <v-col cols="12" md="6" class="fill-height">
          <v-card class="pa-4 text-center fill-height" style="height: 95%">
            <div class="mb-4">Formações</div>
            <PieChart :chartData="dataPizza" />
          </v-card>
        </v-col>

        <v-col cols="12" md="6">
          <v-row class="fill-height">
            <v-col cols="12" md="12">
              <v-card class="fill-height d-flex flex-column justify-center align-center" >
                <div>Presenças</div>
                <div class="d-flex justify-center align-center mt-2">
                  <div class="display-1 font-weight-bold mr-3">{{ dashboard?.info?.totalPresencas}}</div>
                  <v-icon large color="green">mdi-check-circle-outline</v-icon>
                </div>
              </v-card>
            </v-col>

            <v-col cols="12" md="12">
              <v-card class="fill-height d-flex flex-column justify-center align-center">
                <div>Ausências</div>
                <div class="d-flex justify-center align-center mt-2">
                  <div class="display-1 font-weight-bold mr-3">{{ dashboard?.info?.totalAusencias}}</div>
                  <v-icon large color="red">mdi-clock-time-four-outline</v-icon>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <!-- Grafico Barra-->

      <v-row >
        <v-col cols="12" md="12">
          <v-card class="pa-4" elevation="2">
            <div class="d-flex justify-space-between align-center mb-2">
              <span>Formações por GRE</span>
              <v-btn icon @click="toggleSort">
                <v-icon>mdi-sort</v-icon>
              </v-btn>
            </div>

            <HorizontalBarChart :chartData="barChartData" />
          </v-card>
        </v-col>
      </v-row>

      <v-row class="btn-group">
        <v-col class="text-end">
          <v-btn
              color="primary"
              @click="exportarDadosPdf"
              outlined
          >
            Exportar Gráficos
          </v-btn>
        </v-col>
      </v-row>
    </div>
    <ListarFormacaoPorStatusGreDialog
        v-if="dialogListarFormacaoStatusGre.visible"
        :visible="dialogListarFormacaoStatusGre.visible"
        :content="dialogListarFormacaoStatusGre.content"
        @onClose="dialogListarFormacaoStatusGre.close()"
    ></ListarFormacaoPorStatusGreDialog>

    <ListarFormacoesGreDialog
        v-if="dialogListarFormacoesGre.visible"
        :visible="dialogListarFormacoesGre.visible"
        :content="dialogListarFormacoesGre.content"
        @onClose="dialogListarFormacoesGre.close()"
    ></ListarFormacoesGreDialog>

    <ListarParticipantesGreDialog
        v-if="dialogListarParticipantesGre.visible"
        :visible="dialogListarParticipantesGre.visible"
        :content="dialogListarParticipantesGre.content"
        @onClose="dialogListarParticipantesGre.close()"
    ></ListarParticipantesGreDialog>

  </div>
</template>

<script>
import {Dialog} from "commons/classes/dialog";
import ListarFormacaoPorStatusGreDialog from "../dialogs/GRE/ListarFormacaoPorStatusDialog.vue";
import ListarFormacoesGreDialog from "../dialogs/GRE/ListarFormacoesDialog.vue";
import ListarParticipantesGreDialog
  from "~/views/post-login/administrador/manter-dashboard-formacao/dialogs/GRE/ListarParticipantesDialog.vue";
import {Dashboard} from "commons/classes/dashboard";
import DashboardFormacaoService from "services/dashboard-formacao.service";
import AuthService from "services/auth.service";

export default {
  name: "ManterDashboardFormacaoGreView",
  mixins: [DashboardFormacaoService, AuthService],
  components: {
    StatusFormacao: () => import('../components/StatusFormacao.vue'),
    PieChart: () => import('@/components/Graficos/PieChart.vue'),
    HorizontalBarChart: () => import('@/components/Graficos/HorizontalBarChart.vue'),
    //dialogs
    ListarFormacaoPorStatusGreDialog,
    ListarFormacoesGreDialog,
    ListarParticipantesGreDialog,
  },
  data: () => ({
    dialogListarFormacaoStatusGre: Dialog.Build(),
    dialogListarFormacoesGre: Dialog.Build(),
    dialogListarParticipantesGre: Dialog.Build(),
    dataPizza: {
      labels: ['Realizadas', 'Não realizadas'],
      datasets: [
        {
          data: [0, 0],
          backgroundColor: ['#3F51B5', '#4CAF50']
        }
      ]
    },
    sortAsc: false,
    greData: [],
    dashboard: null,
    form:{
      filters: {
        gre: null,
      },
      listaGerenciasRegionais: [],
    },
  }),
  methods: {
    openDialogListarStatusFormacao() {
      this.dialogListarFormacaoStatusGre.open(new Dashboard({id: this.dashboard.greCodigo, origemId: 1}));
    },
    openDialogListarFormacoesGre() {
      this.dialogListarFormacoesGre.open(new Dashboard({id: this.dashboard.greCodigo, origemId: 1}));
    },
    openDialogListarParticipantesGre() {
      this.dialogListarParticipantesGre.open(new Dashboard({id: this.dashboard.greCodigo, origemId: 1}));
    },
    buscarDashboardGre() {
      this.dashboard = null;
      this.$buscarDashboardGre({ params: {greCodigo: this.form.filters.gre?.codigo} }).then(
          ({ data }) => {
            this.dashboard = data.dashboard
            this.dataPizza.datasets[0].data = data?.dashboard?.grafico?.dataPizza;
            this.greData = data?.dashboard?.grafico?.greData
          }
      )
    },

    //uteis
    resetForm() {
      this.$resetForm();
      this.dashboard = null;
    },
    toggleSort() {
      this.sortAsc = !this.sortAsc;
    },
    async exportarDadosPdf() {
      this.showPageLoading();
      try {
        const { data } = await this.$buscarDashboardGrePdf(this.$montarParamsFilters(
            {greCodigo: this.form.filters.gre?.codigo}));
        const url = URL.createObjectURL(data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "SIGFOCO.FormacoesGRE.pdf");
        document.body.appendChild(link);
        link.click();
        this.$notifySuccess("Operação realizada com sucesso.");
      } finally {
        this.hidePageLoading();
      }
    },
  },
  computed: {
    sortedData() {
      return [...this.greData].sort((a, b) =>
          this.sortAsc ? a.value - b.value : b.value - a.value
      );
    },
    barChartData() {
      return {
        labels: this.sortedData.map(item => item.label),
        datasets: [
          {
            label: 'Formações',
            backgroundColor: '#3F51B5',
            data: this.sortedData.map(item => item.value)
          }
        ]
      };
    }
  },
  mounted() {
    this.$obterListaGerenciasRegionais().then(({ data }) => {
      this.form.listaGerenciasRegionais = data.lista;
    });
  },
}
</script>